var render = function render(){var _vm=this,_c=_vm._self._c;return _c('textarea',_vm._g(_vm._b({ref:"input",class:_vm.className,style:(_vm.style),attrs:{"aria-invalid":_vm.invalid ? 'true' : 'false'},domProps:{"value":_vm.value}},'textarea',_vm.$attrs,false),_vm.listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }